import React, { useRef, useEffect, useState } from "react";
import Search from "../containers/Search";
import { Search as SearchIcon, X } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setFilterSort } from "../../server/Product";
import ProductFilters from "../routs/categoryPage/ProductFilters";

function isFilterRoute(pathname) {
  return (
    pathname.includes("/category/") ||
    pathname.includes("/search") ||
    pathname.includes("/sales")
  );
}

const HeaderSearch = () => {
  const [showMobileSearch, setShowMobileSearch] = useState(false);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  const filterAndSort = useSelector(
    (state) => state.displayProduct?.filterAndSort ?? false,
  );

  const panelRef = useRef(null);

  /* Close panel on click outside */
  useEffect(() => {
    if (!filterAndSort) return undefined;
    const handler = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) {
        dispatch(setFilterSort(false));
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [filterAndSort, dispatch]);

  const close = () => dispatch(setFilterSort(false));

  return (
    <>
      {/* Desktop: search bar + dropdown panel anchored below it */}
      <div className="desk-search" ref={panelRef}>
        <Search />

        {isFilterRoute(pathname) && (
          <div
            className={`search-dropdown-panel${filterAndSort ? "" : " search-dropdown-panel--hidden"}`}
            dir="rtl"
          >
            {/* Header — identical structure to the original cart-drawer filter header */}
            <header className="cart-drawer__head">
              <div className="cart-drawer__head-text">
                <h2 className="cart-drawer__head-title">מיון וסינון</h2>
              </div>
              <button
                type="button"
                className="cart-drawer__head-close"
                onClick={close}
                aria-label="סגור"
              >
                <X size={20} strokeWidth={2} aria-hidden />
              </button>
            </header>

            {/* Filters — same body/scroll structure as original filter drawer */}
            <div className="cart-drawer__body cart-drawer__body--filters">
              <div className="cart-drawer__filters-scroll">
                <ProductFilters />
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Mobile: icon that toggles the search bar */}
      <div className="mobile-search">
        <button
          className="icon"
          onClick={() => setShowMobileSearch(!showMobileSearch)}
          type="button"
          aria-label="חיפוש"
        >
          <SearchIcon aria-hidden size={22} strokeWidth={2} />
        </button>
        {showMobileSearch ? (
          <div className="search">
            <Search />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default HeaderSearch;
